import { defHttp } from '/@/utils/http/axios';
import {
  LoginParams,
  LoginResultModel,
  GetUserInfoModel,
  GetPictureModel,
} from './model/userModel';

import { ErrorMessageMode } from '/#/axios';

enum Api {
  Login = '/partner/auth/username-login',
  LoginByWeChat = '/partner/auth/wxLogin/',
  UnbindWeChat = '/partner/auth/wxLoginUnbind',
  GetPictureCode = '/code',
  Logout = '/partner/auth/logout',
  GetUserInfo = '/partner/user/loginInfo',
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>({ url: Api.Login, params }, { errorMessageMode: mode });
}
export function loginByWeChat(code: string) {
  return defHttp.post({ url: `${Api.LoginByWeChat}${code}` });
}
export function unbindWeChat() {
  return defHttp.post({ url: Api.UnbindWeChat });
}
/**
 * @description: getPictureCode
 */
export function getPictureCode() {
  return defHttp.get<GetPictureModel>({ url: Api.GetPictureCode }, { isTransformResponse: false });
}
/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>({ url: Api.GetUserInfo }, { errorMessageMode: 'none' });
}

export const getPermCode = () => ['1000', '3000', '5000'];

export const doLogout = () => defHttp.delete({ url: Api.Logout });
